import React from "react";
import { Button } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import PageHeader from "../../shared/components/PageHeader";

// Page-header definition for the legacy v1 staff-detail pages. The staff member's
// name is the title, the per-staff section menu (Account, ...) becomes the header
// tabs, and the "Return to Staff List" link is the only action. The tab set is
// permission-gated v1-side and handed over as plain data; navigation routes
// through onNavigate and onReturnToList, so the inert MemoryRouter is never used
// to navigate. Mirrors StudentInfoHeader.
export default function StaffInfoHeader({
  staffName,
  tabs = [],
  activeKey,
  onNavigate,
  onReturnToList,
}) {
  return (
    <PageHeader
      title={staffName || "Loading..."}
      tabs={tabs.map((t) => ({
        key: t.key,
        label: t.label,
        onClick: t.key === activeKey ? undefined : () => onNavigate(t.url),
      }))}
      activeTab={activeKey}
      actions={
        <Button
          onClick={onReturnToList}
          startIcon={<ArrowBackRoundedIcon />}
          size="small"
          sx={{ flexShrink: 0, whiteSpace: "nowrap", textTransform: "none" }}
        >
          Return to Staff List
        </Button>
      }
    />
  );
}
